import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'spa-number-input',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => NumberInputComponent),
    },
  ],
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberInputComponent implements ControlValueAccessor {
  input = new FormControl<string | null>(null);
  @Input() minimum: number | null = null;
  @Input() maximum: number | null = null;
  @Input() placeholder = '';
  @Input() label = '';
  @Input() limitLength = 1;
  @Input() isTimeInput = false;
  @Input() readonly = false;
  @Input() isRequired = false;
  @Input() errorMessage: string | null = null;

  formatAndValidateInput(event: KeyboardEvent): void {
    if (
      event.key != 'Backspace' &&
      event.key != 'Tab' &&
      event.key != 'Enter' &&
      event.key != 'Delete' &&
      event.key != 'ArrowLeft' &&
      event.key != 'ArrowRight'
    ) {
      const pattern = /[0-9]/;
      const inputChar = event.key;

      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

  reformatInput(value: string): void {
    value = value.replace(/\D/g, '');
    this.input.setValue(value);
    if (this.maximum && +value > this.maximum) {
      this.input.setValue(this.maximum.toString());
    } else if (this.minimum && +value < this.minimum) {
      this.input.setValue(this.minimum.toString());
    } else if (value.length === 1 && this.isTimeInput) {
      this.input.setValue(value.padStart(2, '0'));
    }
    this.onChange(this.input.value ?? '');
  }

  onChange: (obj: string) => void = () => {
    /** do nothing */
  };

  onTouched = () => {
    /** do nothing */
  };

  registerOnChange(fn: (obj: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(input: string): void {
    if (input != null) {
      this.input.setValue(input);
    }
  }
}
